import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { QuestionIcon } from "components/icons/QuestionIcon";
import { FINALLY_WHERE_TO_FIND_ITEMS } from "./constants";

export const FinallyWhereToFindAccordion = () => (
  <Accordion.Root type="multiple" className="t-flex t-flex-col t-gap-4 t-mt-2">
    <Accordion.Item value="Where to find on Finally">
      <Accordion.Trigger className="sm:t-p-3 sm:t-text-body-sm">
        <div className="t-flex t-items-center t-gap-2">
          <QuestionIcon />
          Where to find on Finally
        </div>
      </Accordion.Trigger>

      <Accordion.Content className="t-flex t-flex-col t-gap-6">
        <Accordion.ItemGrid>
          <div className="t-col-span-2 t-flex t-flex-col t-gap-3 t-font-normal t-text-subtext">
            {FINALLY_WHERE_TO_FIND_ITEMS.map(({ label, description }) => (
              <div key={label}>
                <span className="t-text-text-100 t-font-medium t-text-subtext-sm">
                  {label}
                </span>{" "}
                <span className="t-text-text-60 t-text-subtext-sm">
                  {description}
                </span>
              </div>
            ))}
          </div>
        </Accordion.ItemGrid>
      </Accordion.Content>
    </Accordion.Item>
  </Accordion.Root>
);
